import React from 'react';
import { Accordion, Button } from '../../elements';
import styles from './style.module.css';

import White_Icon1 from '../../../assets/img/icon/accordion-white-icon1.svg';
import White_Icon2 from '../../../assets/img/icon/accordion-white-icon2.svg';
import White_Icon3 from '../../../assets/img/icon/accordion-white-icon3.svg';
import White_Icon4 from '../../../assets/img/icon/accordion-white-icon4.svg';
import Blue_Icon1 from '../../../assets/img/icon/accordion-blue-icon1.svg';
import Blue_Icon2 from '../../../assets/img/icon/accordion-blue-icon2.svg';
import Blue_Icon3 from '../../../assets/img/icon/accordion-blue-icon3.svg';
import Blue_Icon4 from '../../../assets/img/icon/accordion-blue-icon4.svg';

export default function CaseStudySection() {
  // for Accordion needs
  const accordionData = [
    {
      id: 1,
      icon: [White_Icon1, Blue_Icon1],
      title: 'Tanggung Jawab Sosial Perusahaan',
      description:
        'Sebagai perusahaan energi nasional, Pertamina berkomitmen untuk senantiasa memprioritaskan keseimbangan dan kelestarian alam, lingkungan dan masyarakat. Dengan menyejahterakan manusia, alam, dan lingkungan, maka Pertamina akan mampu mencapai pertumbuhan bisnis yang berkelanjutan. ',
    },
    {
      id: 2,
      icon: [White_Icon2, Blue_Icon2],
      title: 'Pertamina Village',
      description:
        'Sebagai perusahaan energi nasional, Pertamina berkomitmen untuk senantiasa memprioritaskan keseimbangan dan kelestarian alam, lingkungan dan masyarakat. Dengan menyejahterakan manusia, alam, dan lingkungan, maka Pertamina akan mampu mencapai pertumbuhan bisnis yang berkelanjutan. ',
    },
    {
      id: 3,
      icon: [White_Icon3, Blue_Icon3],
      title: 'Employee Volunteerism',
      description:
        'Sebagai perusahaan energi nasional, Pertamina berkomitmen untuk senantiasa memprioritaskan keseimbangan dan kelestarian alam, lingkungan dan masyarakat. Dengan menyejahterakan manusia, alam, dan lingkungan, maka Pertamina akan mampu mencapai pertumbuhan bisnis yang berkelanjutan. ',
    },
    {
      id: 4,
      icon: [White_Icon4, Blue_Icon4],
      title: 'Disaster Management',
      description:
        'Sebagai perusahaan energi nasional, Pertamina berkomitmen untuk senantiasa memprioritaskan keseimbangan dan kelestarian alam, lingkungan dan masyarakat. Dengan menyejahterakan manusia, alam, dan lingkungan, maka Pertamina akan mampu mencapai pertumbuhan bisnis yang berkelanjutan. ',
    },
  ];

  return (
    <div className={styles.root}>
      <div className={styles.leftSide}>
        <Accordion data={accordionData} />
      </div>
      <div className={styles.rightSide}>
        <h2>STUDI KASUS</h2>
        <span>Studi kasus penggunaan Pertamina Water Tools di EP Sukowati</span>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.
        </p>
        <p>
          Sed ut perspiciatis unde omnis iste natus error sit voluptatem
          accusantium doloremque laudantium, totam rem aperiam.
        </p>
        <Button label="Baca Selengkapnya" color="red" blockBtn />
      </div>
    </div>
  );
}
